namespace TotalPoll {
    // @ts-ignore
    import Controller = TotalCore.Common.Controller;

    @Controller('controllers.totalpoll')
    // @ts-ignore
    export class TranslationsCtrl {
        public language = null;
        public placeholders = {};

        constructor(private $scope) {
            $scope.$watch('$ctrl.language', this.translationAware.bind(this));
            $scope.$watch('$root.settings.fields', this.translationAware.bind(this), true);
        }

        isCurrentLanguage(language) {
            return this.language.code === language.code;
        }

        setLanguage(language) {
            this.language = language;
        }

        private translationAware() {
            if (this.language !== null) {
                this.$scope.settings.fields.forEach((field) => {
                    if (field.options == undefined) return;

                    if (field.translations == undefined) {
                        field.translations = {};
                    }

                    if (field.translations[this.language.code] == undefined) {
                        field.translations[this.language.code] = {options: {}};
                    }

                    let translated = {};

                    this.parseOptions(field.options).forEach((item) => {
                        this.placeholders[field.uid + '-' + item[0]] = item[1];
                        translated[item[0]] = field.translations[this.language.code].options[item[0]] || item[1];
                    });

                    field.translations[this.language.code].options = translated;

                })
            }
        }

        protected parseOptions(options: string) {
            return options
                .split(/\n/g).map((option) => option.split(':', 2).map(item => item.trim()))
                .filter((item) => item.toString().trim().length > 0);
        }
    }
}
